import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TPricingStore,
	TAvailablePlansResponsePayload,
	TCurrentPlanResponsePayload,
	TRequestNewPlanRequest,
	TRequestedPlanResponsePayload,
} from './types';
// ==========================================:
export const initialState: TPricingStore = {
	availablePlans: null,
	availablePlansLoader: false,
	currentPlan: null,
	currentPlanLoader: false,
	requestNewPlanLoader: false,
	requestedPlan: null,
	requestedPlanLoader: false,
};

// ==========================================:
const pricing = createSlice({
	name: '@@pricing',
	initialState,
	reducers: {
		getAvailablePlansRequest: (state: TPricingStore) => {
			const pricingState = state;
			pricingState.availablePlansLoader = true;
		},
		getAvailablePlansSuccess: (
			state: TPricingStore,
			action: PayloadAction<TAvailablePlansResponsePayload>,
		) => {
			const { payload } = action;
			const pricingState = state;
			pricingState.availablePlans = payload;
			pricingState.availablePlansLoader = false;
		},
		getCurrentPlanRequest: (state: TPricingStore) => {
			const pricingState = state;
			pricingState.currentPlanLoader = true;
		},
		getCurrentPlanSuccess: (
			state: TPricingStore,
			action: PayloadAction<TCurrentPlanResponsePayload>,
		) => {
			const { payload } = action;
			const pricingState = state;
			pricingState.currentPlan = payload;
			pricingState.currentPlanLoader = false;
		},
		requestNewPlanRequest: (
			state: TPricingStore,
			action: PayloadAction<TRequestNewPlanRequest>,
		) => {
			const pricingState = state;
			pricingState.requestNewPlanLoader = true;
		},
		requestNewPlanSuccess: (state: TPricingStore) => {
			const pricingState = state;
			pricingState.requestNewPlanLoader = false;
		},
		getRequestedPlanRequest: (state: TPricingStore) => {
			const pricingState = state;
			pricingState.requestedPlanLoader = true;
		},
		getRequestedPlanSuccess: (
			state: TPricingStore,
			action: PayloadAction<TRequestedPlanResponsePayload>,
		) => {
			const { payload } = action;
			const pricingState = state;
			pricingState.requestedPlan = payload;
			pricingState.requestedPlanLoader = false;
		},

		pricingInitState: () => initialState,
	},
});

export default pricing.reducer;
export const {
	getAvailablePlansRequest,
	getAvailablePlansSuccess,
	getCurrentPlanRequest,
	getCurrentPlanSuccess,
	requestNewPlanRequest,
	requestNewPlanSuccess,
	getRequestedPlanRequest,
	getRequestedPlanSuccess,
	pricingInitState,
} = pricing.actions;
